module.exports = {
    Batches: [
        {
            eval: (i, k) => {
                return i + (i + 1) * (k / 12)
            },
            alteval: (i, k) => {
                return i + (i + 1) * (k / 6)
            },
            constraint: i => {
                //return i % 12 === 0
                return i % 6 === 0
            },
            altconstraint: i => {
                return i % 6 === 0
            },
            limit: 12,
            altlimit: 6
        }, 
        {
            eval: (i, k) => {
                return i + (i + 1) * (k / 12)
            },
            alteval: (i, k) => {
                return i + (i + 1) * (k / 6)
            },
            constraint: i => {
                //return i % 6 === 0 && i % 12 !== 0
                return i % 3 === 0 && i % 6 !== 0
            },
            altconstraint: i => {
                return i % 3 === 0 && i % 6 !== 0
            },
            limit: 24,
            altlimit: 12
        }, 
        {
            eval: (i, k) => {
                //return i + Math.ceil((i + 1) / 2)
                return 1 + 2 * i/*i + Math.ceil((i + 1) / 2)*/
            },
            alteval: (i, k) => {
                return 1 + 2 * i/*i + Math.ceil((i + 1) / 2)*/
            },
            constraint: i => {
                return i % 2 === 0 && i % 6 !== 0
                //return i % 2 === 0 && i % 6 !== 0
            },
            altconstraint: i => {
                return i % 2 === 0 && i % 6 !== 0
            },
            limit: 48,
            altlimit: 24
        }, 
        {
            eval: (i, k) => {
                //return 1 + 2 * i
                let index = [1,5,7,11,13,17,19,23,25,29,31,35,37,41,43,47,49,53,55,59,61,65,67,71]
                return index[i]
            },
            alteval: (i, k) => {
                let index = [1,5,7,11,13,17,19,23,25,29,31,35,37,41,43,47,49,53,55,59,61,65,67,71]
                return index[i]
            },
            constraint: i => {
                //return i % 2 !== 0
                let num = [1,5,7,11,13,17,19,23,25,29,31,35,37,41,43,47,49,53,55,59,61,65,67,71]
                return num.includes(i)
            },
            altconstraint: i => {
                let num = [1,5,7,11,13,17,19,23,25,29,31,35,37,41,43,47,49,53,55,59,61,65,67,71]
                return num.includes(i)
            },
            limit: 72,
            altlimit: 36
        }
    ]
}